import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["submit"]; }

  updateSubmitButtonState(event) {
    this.submitTarget.disabled = event.target.value.trim().length === 0;
  }
}
